const routes = {
  // Roots
  home: "/",
  algoritmo: "/algoritmo",
  items: "/items",
  coleccion: "/collection",
  redeem: "/redeem",
  ok_redeem: "/ok-redeem",
  authentication: "/auth",
  my_coleccion: "/my-collection",
  archive: "/archive",
  archive_detail: "/archive-detail",
  the_artist: "/the-artist",
  fancy_checkout: "/fancy-checkout",
  paypal_success: "/paypal-success",
  paypal_error: "/paypal-payment-error",
  success_payment: "/success-payment",
  favorites: "/favorites",
  logout: "/logout",
  artworkLanding: "/works",
  news: "/news",
  news_detail: "/news/:newsId",
  nfc: "/nfc",
  certificate: "/certificate",
  /*
    checkout: "/checkout",
    homepage: "/homepage",
    landing: "/landing",
    discover: "/discover",
  */

  sellers_login: "/sellers-login",
  comercial_checkout: "/comercial-checkout",
  revelated_list: "/revelated-list",

  // Nested Dashboard pages
};

export default routes;
